import React from 'react';

import { Content } from './Content.js';
import NrgComponent from './../NrgComponent.jsx';
import getIcon from '../../icons/svgController.js';

export default class OverPipePanel extends NrgComponent {

  render() {
    var panel = Content[this.props.page][this.props.section];
    let Icon = getIcon(panel.iconName);

    return (
      <div className={`OverPipePanel row ${this.props.section}`}>
        <div className="inner">
          <div className="col-xs-16 col-sm-3 col-md-3" data-scroll-item-once>
            <div className="large-icon">
              {panel.iconName && <Icon viewBox="0 0 100 100"></Icon>}
            </div>
            <div className="large-number hidden-md-up">{panel.number}</div>
          </div>
          <div className="col-xs-16 col-sm-11 col-md-10" data-scroll-item-once>
            <div className="main-content">
              <h2>{panel.title}</h2>
              <p dangerouslySetInnerHTML={{__html: panel.body}}></p>
            </div>
          </div>
          <div className="hidden-sm-down col-sm-2 col-md-3" data-scroll-item-once>
            <div className="large-number">{panel.number}</div>
          </div>
        </div>
      </div>
    );
  }

};
